/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Observable, of } from 'rxjs';
import { District } from '../models/models';
import { Injectable } from '@angular/core';
import { IDistrictService } from './iDistrict.service';

@Injectable()
export class DistrictService extends IDistrictService {
    getDistricts(): Observable<District[]> {
        const districts: District[] = [
            <District> {id:'HQ', name:'HQ'},
            <District> {id:'ALT', name:'ALT'},
            <District> {id:'OKCOWY', name:'OKCOWY'},
            <District> {id:'STX', name:'STX'},
            <District> {id:'WTX', name:'WTX'},
            <District> {id:'PA', name:'PA'},
            <District> {id:'ND', name:'ND'},
            <District> {id:'R&D', name:'R&D'}

        ];
        return of(districts) ;
    };

    getDistrict(districtId: string): Observable<District> {
        throw new Error('Method not implemented.');
    }

    createDistrict(districtName: string): Observable<any> {
        throw new Error('Method not implemented.');
    }

    updateDistrict(districtId: string, updatedName: string): Observable<any> {
        throw new Error('Method not implemented.');
    }

    deleteDistrict(districtId: string): Observable<any> {
        throw new Error('Method not implemented.');
    }
}
